import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { QueryPatient } from '@xmedical/core';

@Component({
  selector: 'xcs-patient-duplicates-banner',
  templateUrl: './patient-duplicates-banner.component.html',
  styleUrls: ['./patient-duplicates-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatListModule],
})
export class PatientDuplicatesBannerComponent {
  readonly duplicates = input.required<QueryPatient[]>();
  readonly hasTabs = input(false);
  readonly initialOpen = input(false);

  readonly selectEdit = output<QueryPatient>();

  // Local UI state — opened by the parent's auto-open rule via initialOpen,
  // toggled by the user from there.
  private readonly userToggled = signal<boolean | null>(null);

  readonly isOpen = computed(() => this.userToggled() ?? this.initialOpen());

  toggle(): void {
    this.userToggled.set(!this.isOpen());
  }

  edit(duplicate: QueryPatient): void {
    this.selectEdit.emit(duplicate);
  }
}
